import { ChartRefObject } from '@opengov/reporting-charts';
import React, { createContext, useContext, useRef } from 'react';

type AppContextType = {
  reportChartVisualizationRef: React.RefObject<ChartRefObject>;
};

const AppContext = createContext<AppContextType | null>(null);

export const AppProvider: React.FC = ({ children }) => {
  const reportChartVisualizationRef = useRef<ChartRefObject>(null);

  return <AppContext.Provider value={{ reportChartVisualizationRef }}>{children}</AppContext.Provider>;
};

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};
